import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { FileHelper } from 'src/app/shared/helpers/open-pfd.helper';
import { ClientService } from 'src/app/shared/services/client.service';
import { FinancijeIosService } from 'src/app/shared/services/financije-ios.service';
import { KontniPlanService } from 'src/app/shared/services/kontni-plan.service';

@Component({
  selector: 'app-ios-modal-all',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, TranslateModule],
  templateUrl: './ios-modal-all.component.html',
  styleUrl: './ios-modal-all.component.scss'
})
export class IosModalAllComponent {
  komitenti;
  konta;
  loading = {};

  lastDay() {
    let date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    let pipedDate = this.datePipe.transform(lastDay, 'yyyy-MM-ddT23:59');
    return pipedDate;
  }

  form = new UntypedFormGroup({
    odKomitenta: new UntypedFormControl(0, Validators.required),
    doKomitenta: new UntypedFormControl(99999999, Validators.required),
    naDan: new UntypedFormControl(this.lastDay(), Validators.required),
    konto: new UntypedFormControl('2110', Validators.required),
  });

  constructor(private clientService: ClientService,
    private iosService: FinancijeIosService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private translate: TranslateService,
    private bsModalRef: BsModalRef,
    private kontniPlanService: KontniPlanService) { }

  ngOnInit(): void {
    this.getKomitente();
    this.getKonta();
  }

  onSubmit() {
    this.loading['getIos'] = true
    this.iosService.getPdfAll(this.form.value).subscribe((res) => {
      this.loading['getIos'] = false
      FileHelper.downloadFile(res);
    }, error => {
      this.toastr.error(this.translate.instant("MESSAGE.IOS prazan"));
      this.loading['getIos'] = false
    });
  }

  getKomitente() {
    this.clientService.getAllClients().subscribe(resp => {
      this.komitenti = resp;
    })
  }

  getKonta() {
    this.kontniPlanService.getAll().subscribe(resp => {
      this.konta = resp;
      this.konta = this.konta.map((o) => {
        o.search_label = ` ${o.konto!} ${o.opis!}  `;
        return o;
      });
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    let splitTerm = term.split(' ').filter(t => t);
    let isWordThere = [];
    splitTerm.forEach(arr_term => {
      let search = item['search_label'].toLowerCase();
      isWordThere.push(search.indexOf(arr_term) != -1);
    });
    const all_words = (this_word) => this_word;
    return isWordThere.every(all_words);
  }

}
